<template>
  <div class="game-container">
    <div class="passVert" v-if="initData.sharedBlock !== undefined" :style="getStyle(initData.sharedBlock)">
      <h2 style="font-weight: bold">{{ initData.sharedBlock.title }}</h2>
      <ol class="passList" :style="getStyle(initData.sharedBlock.listStyle)" v-if="isList(startGameConfig)">
        <li
          v-for="(item, ix) in corssDataWithoutUndefined"
          :key="'crossdata_' + ix"
          :seq="ix + 1"
          v-html="item.txt"
        ></li>
      </ol>
      <div class="passList" :style="getStyle(initData.sharedBlock.listStyle)" v-else>
        <div
          v-for="(item, ix) in corssDataWithoutUndefined"
          :key="'crossdata_' + ix"
          :seq="ix + 1"
          v-html="item.txt"
        ></div>
      </div>
    </div>
    <div class="passVert" v-if="initData.sharedBlock === undefined">
      <h2>PIONOWO:</h2>
      <ol class="passList" :style="getListStyle(initData)">
        <!-- <li v-for="(item, index) in initData.crossdata" :key="'passList_' + index" v-if="item.ver" :seq="item.indx"> -->
        <li v-for="(item, index) in isVer" :key="'passList_' + index" :seq="item.indx">
          <img
            v-if="item.src !== undefined"
            :src="item.src"
            :style="{
              height: item.pos !== undefined && item.pos.h !== undefined ? item.pos.h + 'px !important' : false,
              width: item.pos !== undefined && item.pos.w !== undefined ? item.pos.w + 'px !important' : false,
            }"
          /><span v-else v-html="item.txt"></span>
        </li>
      </ol>
    </div>
    <div class="crossword-container" :style="getStyle(startGameConfig)">
      <table class="crossword">
        <tr v-for="(row, i) in diagram" :key="'row_' + i">
          <td
            v-for="(col, j) in row"
            :key="'col_' + j"
            :class="[
              { null: isNull(diagram[i][j].correct) },
              { answer: diagram[i][j].static !== true },
              { answerGood: isGood(diagram[i][j]) },
              { answerBad: isWrong(diagram[i][j]) },
              { 'td-answer-static': diagram[i][j].static },
            ]"
            :style="[
              {
                background:
                  !isNull(diagram[i][j].sel) && diagram[i][j].color !== undefined
                    ? diagram[i][j].color + '!important'
                    : false,
              },
              getColorStyle(diagram[i][j]),
            ]"
          >
            <div
              v-if="diagram[i][j].static === true"
              class="answerStatic"
              :ref="diagram[i][j].id"
              :id="diagram[i][j].id"
            >
              {{ diagram[i][j].correct }}
            </div>
            <tr-input
              v-else-if="!isNull(diagram[i][j].correct)"
              :key="diagram[i][j].id"
              :ref="diagram[i][j].id"
              :config="diagram[i][j]"
              :tr-input-value="diagram[i][j]"
              @keyArrowLeft="moveLeft"
              @keyArrowRight="moveRight"
              @keyArrowUp="moveUp"
              @keyArrowDown="moveDown"
              :max-length="1"
              :input-width="startGameConfig.inputWidth"
            ></tr-input>
            <div v-if="!isNull(diagram[i][j].sel)" class="pass" :style="'color:' + setPasswordColor + ';'">
              <span v-if="startGameConfig.numPass !== false && !startGameConfig.numPassColor">{{
                diagram[i][j].sel
              }}</span>
            </div>
            <div
              v-if="!isNull(diagram[i][j].ver) && !hideRowNumber && startGameConfig.numberHorVer !== false"
              class="num ver"
            >
              {{ diagram[i][j].ver }}
            </div>
            <div
              v-if="!isNull(diagram[i][j].hor) && !hideRowNumber && startGameConfig.numberHorVer !== false"
              class="num hor"
            >
              {{ diagram[i][j].hor }}
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="passHor" v-if="initData.sharedBlock === undefined">
      <h2>POZIOMO:</h2>
      <ol class="passList" :style="getListStyle(initData)">
        <!-- <li v-for="(item, index) in initData.crossdata" :key="'crossdata_' + index" v-if="!item.ver" :seq="item.indx"> -->
        <li v-for="(item, index) in notVer" :key="'crossdata_' + index" :seq="item.indx">
          <img
            v-if="item.src !== undefined"
            :src="item.src"
            :style="{
              height: item.pos !== undefined && item.pos.h !== undefined ? item.pos.h + 'px !important' : false,
              width: item.pos !== undefined && item.pos.w !== undefined ? item.pos.w + 'px !important' : false,
            }"
          /><span v-else v-html="item.txt"></span>
        </li>
      </ol>
    </div>
    <div class="password" v-if="initData.password !== undefined && initData.showPass !== false">
      <div
        class="password-label-container"
        :style="getPassStyle(initData.sharedBlock)"
        v-if="(startGameConfig.password && startGameConfig.colorPasswordEnable) || startGameConfig.numPass !== false"
      >
        <div v-if="disablePassText" class="password-label1" v-html="passStyleLabel1"></div>
        <div v-if="disablePassText" class="password-label2" style="position: relative" v-html="passStyleLabel2"></div>
        <div
          v-if="startGameConfig.passwordStaticText"
          :style="getStyle(startGameConfig.passwordStaticText)"
          v-html="initData.passwordStaticText.text"
        ></div>
        <table>
          <tr>
            <td
              v-for="(item, i) in password"
              :key="'password_' + i"
              :style="[
                {
                  height: '50px !important',
                  display: 'inline-block',
                  background: item.color !== undefined ? item.color + '!important' : false,
                },
                getColorStyle(item),
              ]"
            >
              <tr-input
                :key="item.letter + '-' + i"
                :ref="item.id"
                :config="item"
                :tr-input-value="password[i]"
                :max-length="1"
                @keyArrowLeft="moveLeft"
                @keyArrowRight="moveRight"
                @keyArrowUp="moveUp"
                @keyArrowDown="moveDown"
                :input-width="startGameConfig.inputWidth"
              ></tr-input>
              <div
                class="pass"
                v-if="startGameConfig.numPass !== false && !startGameConfig.numPassColor"
                style="bottom: 15px"
                :style="'color:' + setPasswordColor + ';'"
              >
                {{ i + 1 }}
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @type {Boolen} startGameConfig.numPass  wlacza/wyalcza pojawianie się hasła do wipsania
 * @type {Boolen} startGameConfig.numPassColor  wlacza/wyalcza pojawianie się indeksow dla pol hasla (najczsciej używane wraz z kolorami)
 * @type {Object} passwordStaticText  obiekt zarządzający statycznym tekstem w hasle
 * @type {Object} passwordStaticText.cssStyle  obiekt zarządzający stylem elementu
 * @type {String} passwordStaticText.text  text statyczny
 * @type {Object} listStyle  obiekt zarządzający wyglądem list pytan
 * @type {Boolen} listStyle.unordered  jeśli true nie wyswietla numerów przed pytaniami
 * @type {Object} listStyle.cssStyle  obiekt zarządzający stylem elementu
 * @type {String}
 */
import _ from 'lodash';
import TrInput from '../TrInput/TrInput';
import defaultMixin from '../../mixins/defaultMixin';
// TODO: add case sensitive to text
export default {
  name: 'mp-crossword2',
  components: { TrInput },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      diagram: [],
      password: [],
    };
  },
  beforeMount() {
    this.initGame();
  },
  mounted() {},
  methods: {
    // testChange($event, payload) {
    //   console.log('testChange', $event);
    //   console.log('payload', payload);
    // },
    // autoMove($event, payload) {
    //   let focusElement = payload.split('-');
    //   console.log('this', this.diagram[focusElement[0]][focusElement[1]]);
    //   if (!_.isNil(this.diagram[focusElement[0]][parseInt(focusElement[1]) + 1].correct)) {
    //     console.log('right', this.diagram[focusElement[0]][parseInt(focusElement[1]) + 1]);
    //     this.moveRight($event, payload);
    //   } else if (!_.isNil(this.diagram[parseInt(focusElement[0]) + 1][parseInt(focusElement[1])].correct)) {
    //     console.log('down', this.diagram[parseInt(focusElement[0]) + 1][parseInt(focusElement[1])]);
    //     this.moveDown($event, payload);
    //   }
    // },
    moveCursor(focusElement) {
      if (this.$refs[focusElement]) {
        this.$refs[focusElement][0].$el.querySelector('input').select();
      }
    },
    testNextPossibleCell(focusElement) {
      if (_.isString(focusElement)) {
        // console.log('test', this.$refs[focusElement][0].className);
        if (this.$refs[focusElement] && this.$refs[focusElement][0] && this.$refs[focusElement][0].config) {
          return this.$refs[focusElement][0].config.block;
        } else if (
          this.$refs[focusElement] &&
          this.$refs[focusElement][0] &&
          this.$refs[focusElement][0].className === 'answerStatic'
        ) {
          return true;
        }
      }
      return false;
    },
    splitIdPosition(idString, type, range = 1) {
      let focusElement = idString.split('-');
      if (focusElement.length === 2) {
        focusElement = _.map(focusElement, (item, index) => {
          switch (type) {
            case 'left':
              if (index === 1) {
                return parseInt(item) - parseInt(range);
              }
              return parseInt(item);
              break;
            case 'right':
              if (index === 1) {
                return parseInt(item) + parseInt(range);
              }
              return parseInt(item);
              break;
            case 'up':
              if (index === 0) {
                return parseInt(item) - parseInt(range);
              }
              return parseInt(item);
              break;
            case 'down':
              if (index === 0) {
                return parseInt(item) + parseInt(range);
              }
              return parseInt(item);
              break;
          }
        });
      } else if (focusElement.length === 3) {
        focusElement = _.map(focusElement, (item, index) => {
          switch (type) {
            case 'left':
              if (index === 1) {
                return parseInt(item) - parseInt(range);
              }
              return item;
              break;
            case 'right':
              if (index === 1) {
                return parseInt(item) + parseInt(range);
              }
              return item;
              break;
            case 'up':
              if (index === 0) {
                return parseInt(item) - parseInt(range);
              }
              return item;
              break;
            case 'down':
              if (index === 0) {
                return parseInt(item) + parseInt(range);
              }
              return item;
              break;
          }
        });
      }
      focusElement = focusElement.join('-');
      return focusElement;
    },
    moveLeft(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'left');
      let i = 1;
      while (i++ < 4 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'left', i);
      }
      this.moveCursor(focusElement);
    },
    moveRight(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'right');
      let i = 1;
      while (i++ < 4 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'right', i);
      }
      this.moveCursor(focusElement);
    },
    moveUp(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'up');
      let i = 1;
      while (i++ < 4 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'up', i);
      }
      this.moveCursor(focusElement);
    },
    moveDown(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'down');
      let i = 1;
      while (i++ < 4 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'down', i);
      }
      this.moveCursor(focusElement);
    },
    shuffle(a, shuffle) {
      if (a.length == 0) return;
      if (shuffle === true) {
        for (let i = a.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [a[i], a[j]] = [a[j], a[i]];
        }
      }
      return a;
    },
    initGame() {
      this.initData = this.startGameConfig;
      if (this.initData.sharedBlock && this.initData.sharedBlock.shuffle) {
        this.initData.crossdata = _.shuffle(this.initData.crossdata);
      }
      var self = this;
      this.initData.crossword.forEach(function (item, i) {
        // self.diagram[i] = [];
        self.$set(self.diagram, i, []);
        // let row= self.diagram[i];
        for (let j = 0; j < item.length; j++) {
          // self.diagram[i][j] = { correct: null };
          self.$set(self.diagram[i], j, { correct: null });
          if (item[j] != '') {
            var statix = false;
            let replace = [];
            self.initData.crossdata.forEach(function (cd) {
              if (cd.static !== undefined && i == cd.static.x && j == cd.static.y) {
                statix = true;
                replace.push(cd.replace);
              }
            });
            if (!_.isEmpty(replace[i])) {
              self.$set(self.diagram[i], j, {
                id: i + '-' + j,
                correct: item[j],
                replace: replace[i][j],
                val: '',
                static: statix,
                block: false,
                wrong: false,
                inputStatus: null,
                obj: null,
              });
            } else {
              self.$set(self.diagram[i], j, {
                id: i + '-' + j,
                correct: item[j],
                val: '',
                static: statix,
                block: false,
                wrong: false,
                inputStatus: null,
                obj: null,
              });
            }
            // self.diagram[i][j] = {
            //   id: i + '-' + j,
            //   correct: item[j],
            //   val: '',
            //   static: statix,
            //   block: false,
            //   wrong: false,
            //   inputStatus: null,
            //   obj: null
            // };
          }
        }
      });
      // this.password = _.each(this.initData.password, (item, i) => {
      _.each(this.initData.password, (item, i) => {
        this.$set(
          this.password,
          i,
          _.extend({}, item, {
            id: '',
            correct: null,
            val: '',
            block: false,
            wrong: false,
            inputStatus: null,
            obj: null,
            colorField: null,
          })
        );
        // return _.extend(item, {
        //   id: '',
        //   correct: null,
        //   val: '',
        //   block: false,
        //   wrong: false,
        //   inputStatus: null,
        //   obj: null,
        //   colorField: null
        // });
      });
      this.password = this.initData.password;
      if (this.initData.password !== undefined) {
        for (let k = 0; k < this.initData.password.length; k++) {
          let cord = this.password[k].cord;
          this.diagram[cord.y][cord.x].sel = k + 1;
          if (this.password[k].color !== undefined) {
            this.diagram[cord.y][cord.x].color = this.password[k].color;
          }
          // this.password[k].id = 'p-' + k + '-f';
          // this.password[k].val = '';
          // this.password[k].obj = null;
          let id = ['p-', k, '-f'].join('');
          this.$set(this.password[k], 'id', id);
          this.$set(this.password[k], 'val', '');
          this.$set(this.password[k], 'obj', null);
          let colorField = this.password[k].colorField;
          _.each(colorField, (cell) => {
            if (cell.color) {
              // this.password[k].colorField = cell.color;
              this.$set(this.password[k], 'colorField', cell.color);
            }
          });
        }
      }
      for (let k = 0; k < this.initData.crossdata.length; k++) {
        if (!_.isNil(this.initData.crossdata[k].txt) || !_.isNil(this.initData.crossdata[k].src)) {
          this.initData.crossdata[k].indx = this.initData.crossdata[k].indx || k + 1;
          let cord = self.initData.crossdata[k].cord;
          if (this.initData.crossdata[k].ver) {
            this.diagram[cord.x][cord.y].ver = this.initData.crossdata[k].indx;
          } else {
            this.diagram[cord.x][cord.y].hor = this.initData.crossdata[k].indx;
          }
          let colorField = self.initData.crossdata[k].colorField;
          _.each(colorField, (cell) => {
            if (cell.color) {
              this.diagram[cell.x][cell.y].colorField = cell.color;
            }
          });
        }
      }
    },
    newGame() {
      for (let i = 0; i < this.diagram.length; i++) {
        for (let j = 0; j < this.diagram[i].length; j++) {
          if (this.diagram[i][j].val != null) {
            this.$set(this.diagram[i][j], 'block', false);
            this.$set(this.diagram[i][j], 'val', '');
            if (this.diagram[i][j].obj) {
              this.diagram[i][j].obj.inputsVal('');
            }
          }
        }
      }
      if (this.password !== undefined) {
        for (let i = 0; i < this.password.length; i++) {
          this.$set(this.password[i], 'block', false);
          this.$set(this.password[i], 'val', '');
          if (this.password[i].obj) {
            this.password[i].obj.inputsVal('');
          }
        }
      }
    },
    isWrong(a) {
      return a.wrong == true;
    },
    isGood(a) {
      return a.block === true && a.static !== true && this.initData.showGood !== false;
    },
    isNull(a) {
      return a == null;
    },
    resetGameAction() {
      let diagram = this.diagram;
      _.each(diagram, (row, rowIndex) => {
        _.each(row, (col, colIndex) => {
          this.diagram[rowIndex][colIndex].block = false;
        });
      });
      this.resetCheckStatus();
      this.initGame();
    },
    checkGameAction() {
      var isCorrect = true;
      var self = this;
      if (this.password && this.password.length > 0) {
        this.password.forEach(function (item, i) {
          if (item.letter.toUpperCase() != item.val.toUpperCase()) {
            isCorrect = false;
          } else {
            self.$set(self.password[i], 'block', true);
            self.$set(self.password[i], 'correct', true);
          }
        });
      }
      this.initData.crossdata.forEach(function (item, i) {
        // if (item.txt !== undefined) {
        if (!_.isNil(item.txt) || !_.isNil(item.src)) {
          let x;
          let y;
          // if (self.initData.numberHorVer || !_.isBoolean(self.initData.numberHorVer)) {
          //   x = (item.ver) ? item.cord.x + 1 : item.cord.x;
          //   y = (item.ver) ? item.cord.y : item.cord.y + 1;
          // } else {
          //   x = item.cord.x + 1;
          //   y = item.cord.y + 1;
          // }
          x = item.ver ? item.cord.x + 1 : item.cord.x;
          y = item.ver ? item.cord.y : item.cord.y + 1;
          let pass = '';
          let passStatic = '';
          let index;
          if (item.ver) {
            for (index = x; index < x + item.pass.length; index++) {
              if (
                self.diagram[index] !== undefined &&
                self.diagram[index][y] !== undefined &&
                self.diagram[index][y].static
              ) {
                pass += self.diagram[index][y].correct;
                passStatic += self.diagram[index][y].correct;
              } else {
                if (
                  self.diagram[index] !== undefined &&
                  self.diagram[index][y] !== undefined &&
                  self.diagram[index][y].val
                ) {
                  pass += self.diagram[index][y].val;
                }
              }
            }
            if (pass.toUpperCase() === item.pass) {
              for (index = x; index < x + item.pass.length; index++) {
                self.diagram[index][y].block = true;
              }
            } else if (pass !== '' && pass !== passStatic) {
              for (index = x; index < x + item.pass.length; index++) {
                if (
                  self.diagram[index] !== undefined &&
                  self.diagram[index][y] !== undefined &&
                  self.diagram[index][y].static !== true
                ) {
                  self.diagram[index][y].wrong = true;
                }
              }
            }
          } else {
            for (index = y; index < y + item.pass.length; index++) {
              if (self.diagram[x] !== undefined && self.diagram[x][index] && self.diagram[x][index].static) {
                pass += self.diagram[x][index].correct;
                passStatic += self.diagram[x][index].correct;
              } else {
                if (
                  self.diagram[x] !== undefined &&
                  self.diagram[x][index] !== undefined &&
                  self.diagram[x][index].val
                ) {
                  pass += self.diagram[x][index].val;
                }
              }
            }
            if (pass.toUpperCase() === item.pass) {
              for (index = y; index < y + item.pass.length; index++) {
                self.diagram[x][index].block = true;
              }
            } else if (pass !== '' && pass !== passStatic) {
              for (index = y; index < y + item.pass.length; index++) {
                if (
                  self.diagram[x] !== undefined &&
                  self.diagram[x][index] !== undefined &&
                  self.diagram[x][index].static !== true
                ) {
                  self.diagram[x][index].wrong = true;
                }
              }
            }
          }
          if (pass.toUpperCase() != item.pass.toUpperCase()) {
            isCorrect = false;
          }
        }
      });
      if (!isCorrect) setTimeout(this.removeWrong, 1000);
      return isCorrect;
    },
    removeWrong() {
      var self = this;
      self.diagram.forEach(function (x) {
        x.forEach(function (y) {
          if (y.wrong === true) y.wrong = false;
        });
      });
    },
    getStyle(item) {
      return _.merge({}, this.getCustomStyle(item));
    },
    getListStyle(item) {
      return _.merge({}, this.getCustomStyle(item.listStyle));
    },
    getPassStyle(item) {
      if (item && item.passStyle) {
        return _.merge({}, this.getCustomStyle(item.passStyle));
      }
      return {};
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    isList(item) {
      if (item && item.sharedBlock && item.sharedBlock.listStyle && item.sharedBlock.listStyle.unordered) {
        return !item.sharedBlock.listStyle.unordered;
      }
      return true;
    },
    getColorStyle(item) {
      if (item && item.colorField) {
        // colorField: [ {
        //   y: 4,
        //   x: 0,
        //   color: 'rgb(22, 162, 231)'
        // } ]
        return {
          'background-color': item.colorField || '#ffffff',
        };
      }
      return {};
    },
  },
  computed: {
    hideRowNumber() {
      if (this.startGameConfig.sharedBlock) {
        return this.startGameConfig.sharedBlock.hideRowNumber;
      }
      return false;
    },
    horizontal() {
      if (this.initData && this.initData.list && this.initData.list.horizontal && this.initData.list.horizontal) {
        return this.initData.list.horizontal;
      }
      return {};
    },
    vertical() {
      if (this.initData && this.initData.list && this.initData.list.vertical && this.initData.list.vertical) {
        return this.initData.list.vertical;
      }
      return {};
    },
    disablePassText() {
      if (_.isBoolean(this.startGameConfig.disablePassText)) {
        return !this.startGameConfig.disablePassText;
      }
      return true;
    },
    passStyleLabel1() {
      if (
        this.startGameConfig.sharedBlock &&
        this.startGameConfig.sharedBlock.passStyle &&
        this.startGameConfig.sharedBlock.passStyle.label1
      ) {
        return this.startGameConfig.sharedBlock.passStyle.label1;
        // NOTE: zastosowane tylko dla wstecznej kompatybilności z ćwiczeniami. W kolenej wersji do wywalenia
      } else if (this.startGameConfig.passStyle && this.startGameConfig.passStyle.label1) {
        return this.startGameConfig.passStyle.label1;
      } else {
        return `Czerwone cyfry od <span style="color:red;">1</span> do <span style="color:red;">${this.initData.password.length}</span> utworzą hasło krzyżówki`;
      }
    },
    passStyleLabel2() {
      if (
        this.startGameConfig.sharedBlock &&
        this.startGameConfig.sharedBlock.passStyle &&
        this.startGameConfig.sharedBlock.passStyle.label2
      ) {
        return this.startGameConfig.sharedBlock.passStyle.label2;
        // NOTE: zastosowane tylko dla wstecznej kompatybilności z ćwiczeniami. W kolenej wersji do wywalenia
      } else if (this.startGameConfig.passStyle && this.startGameConfig.passStyle.label2) {
        return this.startGameConfig.passStyle.label2;
      } else {
        return `HASŁO:`;
      }
    },
    setPasswordColor() {
      if (
        this.initData &&
        this.initData.sharedBlock &&
        this.initData.sharedBlock.passStyle &&
        this.initData.sharedBlock.passStyle.color
      ) {
        return this.initData.sharedBlock.passStyle.color;
      }
      return false;
    },
    notVer() {
      return _.filter(this.initData.crossdata, (item) => {
        return !item.ver;
      });
    },
    isVer() {
      return _.filter(this.initData.crossdata, (item) => {
        return item.ver;
      });
    },
    corssDataWithoutUndefined() {
      return _.filter(this.initData.crossdata, (item) => {
        return item.txt !== undefined;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.game-tr-input {
  background: transparent !important;
}

.game-container {
  display: flex;
  padding-top: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.game-container table {
  border-collapse: collapse;
  font-weight: bold;
}

.game-container td {
  border: 1px solid black;
  vertical-align: central;
  text-align: center;
  position: relative;
  height: 50px;
  width: 50px;
}

.passList {
  list-style: none;
  text-align: left;
  margin-top: 50px;
  font-size: xx-large;
}

.passList li:before {
  content: attr(seq) '. ';
  display: inline-block;
  width: 4em;
  margin-left: -4em;
  text-align: right;
  white-space: pre;
}

.passHor {
  position: absolute;
  left: 50px;
  top: 200px;
  width: 500px;
}

.passVert {
  position: absolute;
  right: 50px;
  top: 200px;
  width: 500px;
}

.crossword .num {
  border: none;
  color: black;
  font-size: 0.5em;
  position: absolute;
}

.crossword .ver {
  bottom: 0;
  left: 40%;
}

.crossword .hor {
  top: 0;
  right: 7px;
}

.pass {
  color: red;
  position: absolute;
  // smaller Element for History
  bottom: -5px;
  left: 3px;
  font-size: 0.4em;
  // bottom: 0;
  // left: 5px;
  // font-size: 0.5em;
}

.crossword .null {
  border: none;
}

.password {
  margin-top: 30px;
}
.password p {
  font-size: 0.6em;
  font-weight: bolder;
}
.password span {
  color: red;
}

.password div {
  padding-bottom: 10px;
}

.answer {
  transition: all 500ms ease 0s;
}
.answerBad {
  background: rgba(196, 26, 26, 0.1) !important;
}
.answerGood {
  background-color: rgba(0, 168, 236, 0.6) !important;
}
.td-answer-static {
  background-color: #74ff9b;
}
.answerStatic {
  // background-color: #74ff9b;
  height: 48px;
  width: 49px;
  line-height: 1.2 !important;
}
.password-label-container {
  .password-label1 {
    font-size: 0.6em;
    font-weight: bolder;
  }
}
</style>
